import { getPublicConfig, pairDevice } from './api.js';

const DEVICE_TOKEN_KEY = 'bitrix-sim-device-token';

function applicationServerKey(value: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  const bytes = Uint8Array.from(atob(base64), (character) =>
    character.charCodeAt(0),
  );
  return new Uint8Array(bytes.buffer);
}

export async function activateNotificationsAndPair(code: string): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Este celular no admite notificaciones web compatibles.');
  }
  const registration = await navigator.serviceWorker.register('/sw.js');
  if (!registration.pushManager) {
    throw new Error('Este celular no admite notificaciones web compatibles.');
  }
  if ('Notification' in window) {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      throw new Error('Debes permitir notificaciones para vincular este celular.');
    }
  }
  const config = await getPublicConfig();
  const subscription =
    (await registration.pushManager.getSubscription()) ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey(config.vapidPublicKey),
    }));
  const paired = await pairDevice(code, subscription.toJSON());
  localStorage.setItem(DEVICE_TOKEN_KEY, paired.deviceToken);
}

export function hasDeviceToken(): boolean {
  return Boolean(localStorage.getItem(DEVICE_TOKEN_KEY));
}

export function getDeviceToken(): string {
  return localStorage.getItem(DEVICE_TOKEN_KEY) ?? '';
}
